/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {

  /**
   * @function loadAutomatically
   * Checks the web address for the parameter that
   * signals that the PatternMaker modal should open by itself
   * after the page and dependencies have loaded.
   * The parameter will be added on the inbound link of the marketing collateral.
   * For example, a Tweet will contain https://www.vans.com/custom-shoes.html?loadPatternMaker=true
   * @returns {Boolean} True to indicate the modal should open as soon as possible.
   */
  loadAutomatically(store, getters, rootState) {
    return rootState.utils.queryParams.loadPatternMaker === "true" || rootState.utils.queryParams.canvas;
  },

  /**
   * @function PatternMakerID
   * Checks the web address for the parameter that
   * signals that the PatternMaker modal should open by itself
   * after the page and dependencies have loaded.
   * The parameter will be added on the inbound link of the marketing collateral.
   * For example, a Tweet will contain https://www.vans.com/custom-shoes.html?loadPatternMaker=true&PatternMakerID=defaultPatterns
   * @returns {String} CTA id name indicate the button id will should open as soon as possible.
   */
  PatternMakerID(store, getters, rootState) {
    return rootState.utils.queryParams.PatternMakerID;
  },

  swatchIdParam(store, getters, rootState) {
    const swatchId = rootState.utils.queryParams.swatchId;
    return swatchId ? Number(rootState.utils.queryParams.swatchId) : null;
  },

  stickerIdParam(store, getters, rootState) {
    const stickerId = rootState.utils.queryParams.stickerId;
    return stickerId ? Number(rootState.utils.queryParams.stickerId) : null;
  },

  isSecondComponentFlow(state, getters, rootState, rootGetters) {
    const secondaryComponent = rootGetters["ugc/getUGCComponentNotActive"];
    const patternAlreadyCreated = state.currentPattern.hasOwnProperty(secondaryComponent);
    return secondaryComponent && patternAlreadyCreated;
  },
};

export default getters;
